import React, { Component } from 'react';
import swal from 'sweetalert';
import * as Sentry from '@sentry/browser';
import actions from 'api/actions';
import emailRegex from 'utils/emailRegex';

class OnboardForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      school_name: '',
      first_name: '',
      last_name: '',
      email: '',
      password: '',
      sent: false,
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleChange(e) {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  }

  handleSubmit(e) {
    e.preventDefault();
    const data = { ...this.state };
    this.setState({ sent: true });
    actions
      .post('organizations/trials', data)
      .then(r => {
        swal({
          title: 'Trial account created!',
          text: 'Check your email for a confirmation link. Click that link to get started.',
          icon: 'success',
        });
      })
      .catch(error => {
        console.error('Error', error);
        Sentry.withScope(scope => {
          scope.setExtra('formData', data);
          Sentry.captureException(error);
        });
        swal({
          title: "We encountered an error in creating your school's community",
          text:
            (error.response.data && error.response.data.error) ||
            'The Unyted team has been notified automatically. We will reach out to you soon.',
          icon: 'error',
        });
      });
  }

  render() {
    const { school_name, first_name, last_name, email, password, sent } =
      this.state;

    const canSubmit =
      school_name.length > 2 &&
      first_name.length > 2 &&
      last_name.length > 2 &&
      email.length > 4 &&
      email.match(emailRegex) &&
      password.length > 5 &&
      !sent;

    return (
      <div className="row">
        <div className="col-md-6 offset-md-3 my-5">
          <div className="card register-panel">
            <div className="card-header">
              <h2>Create a Community</h2>
            </div>
            <div className="card-body">
              <form>
                <div className="form-group">
                  <label htmlFor="school_name">Name your Community</label>
                  <input
                    name="school_name"
                    className="form-control"
                    type="text"
                    placeholder="Ex: Brown Middle School"
                    value={school_name}
                    onChange={this.handleChange}
                  />
                  <small id="school_name_help" className="form-text text-muted">
                    This is typically your school's name.
                  </small>
                </div>
                <div className="form-group">
                  <label htmlFor="first_name">First Name</label>
                  <input
                    name="first_name"
                    className="form-control"
                    type="text"
                    placeholder="Ex: Jill"
                    value={first_name}
                    onChange={this.handleChange}
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="last_name">Last Name</label>
                  <input
                    name="last_name"
                    className="form-control"
                    type="text"
                    placeholder="Ex: Smith"
                    value={last_name}
                    onChange={this.handleChange}
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="email">Email</label>
                  <input
                    name="email"
                    className="form-control"
                    type="email"
                    placeholder="Ex: jsmith@brownmiddle.org"
                    value={email}
                    onChange={this.handleChange}
                  />
                  <small id="email_help" className="form-text text-muted">
                    This is the email address you will use to sign in.
                  </small>
                </div>
                <div className="form-group">
                  <label htmlFor="password">Password</label>
                  <input
                    name="password"
                    className="form-control"
                    type="password"
                    value={password}
                    onChange={this.handleChange}
                  />
                </div>
                {canSubmit ? (
                  <button
                    className="btn btn-primary"
                    onClick={this.handleSubmit}
                  >
                    Create
                  </button>
                ) : (
                  <button className="btn btn-primary" disabled={true}>
                    Create
                  </button>
                )}
              </form>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default OnboardForm;
